import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const RichTextNotesHeader = ({ isRichText = true, isFeedback = false, isEmail = false }) => {
    const header = isEmail ? 'Notes for Subject Line and Rich Text Editor' : 'Notes for Rich Text Editor';
    let body;

    const userTags = (
        <div className={'row user-tags'}>
            Available tag types for current user:&nbsp;&nbsp;
            <span>
                <code>&#123;&#123;firstName&#125;&#125;</code> <code>&#123;&#123;lastName&#125;&#125;</code>
            </span>
            <br />
            <span>
                The <code>&#123;&#123;firstName&#125;&#125;</code> tag defaults to 'there' when no firstName is
                available.
            </span>
        </div>
    );

    const assetLink = (
        <div className={'row link-tags'}>
            <span>
                Link to another learning asset using&nbsp;&nbsp; <code>/assetlink/:learningAssetId</code> URL format.
            </span>
        </div>
    );

    if (isEmail) {
        body = (
            <Fragment>
                {userTags}
            </Fragment>
        );
    } else if (isFeedback) {
        body = (
            <Fragment>
                {userTags}
                <div className={'row'}>
                    Available tag types for participant being assessed:&nbsp;&nbsp;
                    <span>
                        <code>&#123;&#123;employeeFirstName&#125;&#125;</code>{' '}
                        <code>&#123;&#123;employeeLastName&#125;&#125;</code>
                    </span>
                </div>
            </Fragment>
        );
    } else if (isRichText) {
        body = (
            <Fragment>
                {userTags}
                {assetLink}
            </Fragment>
        );
    }

    return (
        <div className={'rich-text-notes-header'}>
            <div className={'row'}>
                <h6>{header}</h6>
            </div>
            {body}
        </div>
    );
};

RichTextNotesHeader.propTypes = {
    isRichText: PropTypes.bool,
    isFeedback: PropTypes.bool,
    isEmail: PropTypes.bool
};

export default RichTextNotesHeader;
